import React, { useState } from "react";
import "./Projects.css";
import { SiVulkan, SiUnity, SiVuedotjs } from "react-icons/si";
import { FaRobot, FaGamepad } from "react-icons/fa";
import useScrollReveal from "../../hooks/useScrollReveal";

const CATEGORIES = ["All", "Games", "Engine", "AI & Tools", "Backend"];

const projects = [
  {
    title: "Yalaz Engine",
    description:
      "Cross-platform 3D rendering engine with PBR, path tracing, skeletal animation, and a full editor.",
    tags: ["Vulkan", "C++20", "CMake"],
    link: "https://github.com/Yalazz/Yalaz-Engine",
    icon: <SiVulkan />,
    category: "Engine",
  },
  {
    title: "SpriteAI",
    description:
      "AI-powered tool that generates game-ready sprite assets from text prompts.",
    tags: ["AI", "Python", "Game Art"],
    link: "https://github.com/Yalazz/SpriteAI",
    icon: <FaRobot />,
    category: "AI & Tools",
  },
  {
    title: "The Lighthouse",
    description:
      "A horror exploration game built in Unity with atmospheric lighting and shader effects.",
    tags: ["Unity", "C#", "Horror"],
    link: "https://github.com/Yalazz/TheLighthouse",
    icon: <FaGamepad />,
    category: "Games",
  },
  {
    title: "Distributed Notification Service",
    description:
      "Real-time data pipelines with RabbitMQ, .NET Core SMTP notification services, PostgreSQL logging, and Vue.js admin interface components — built during SmartIQ internship.",
    tags: ["Vue.js", ".NET Core", "RabbitMQ", "PostgreSQL"],
    link: "https://github.com/Yalazz/APIwithMAIL",
    icon: <SiVuedotjs />,
    category: "Backend",
  },
  {
    title: "Stellar Recon: Kepler",
    description:
      "A detailed and systematic tower defense game built in Unity. Focused on game mechanics, enemy AI, and level design.",
    tags: ["Unity", "C#", "ShaderLab"],
    link: "https://github.com/begumdonmez/g-stellar-recon-kepler",
    icon: <SiUnity />,
    category: "Games",
    collab: { name: "Vusla", url: "https://www.begumdonmez.com/" },
  },
];

export default function Projects() {
  const [active, setActive] = useState("All");
  const gridRef = useScrollReveal({ stagger: true });

  const filtered =
    active === "All" ? projects : projects.filter((p) => p.category === active);

  return (
    <div className="pg-wrapper">
      <div className="pg-filters" role="tablist" aria-label="Project categories">
        {CATEGORIES.map((cat) => (
          <button
            key={cat}
            className={`pg-filter-btn${active === cat ? " pg-filter-btn--active" : ""}`}
            onClick={() => setActive(cat)}
            role="tab"
            aria-selected={active === cat}
          >
            {cat}
          </button>
        ))}
      </div>

      <div className="pg-grid" ref={gridRef}>
        {filtered.map((p, idx) => (
          <article className="pg-card" key={p.title}>
            <header className="pg-head">
              <span className="pg-icon" aria-hidden="true">{p.icon}</span>
              <h3 className="pg-title">{p.title}</h3>
            </header>

            <p className="pg-desc">{p.description}</p>

            {Array.isArray(p.tags) && p.tags.length > 0 && (
              <div className="pg-tags" aria-label="tags">
                {p.tags.map((t, i) => (
                  <span className="pg-tag" key={i}>{t}</span>
                ))}
              </div>
            )}

            {p.collab && (
              <a
                className="pg-collab"
                href={p.collab.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                ft. {p.collab.name}
              </a>
            )}

            {p.link && (
              <a
                className="pg-link"
                href={p.link}
                target="_blank"
                rel="noopener noreferrer"
                title="View Project"
              >
                View Project →
              </a>
            )}
          </article>
        ))}
      </div>
    </div>
  );
}
